import {UPDATE_BOOKINGS, SET_BOOKING_LIST, SET_STATUS_LIST, SET_NAV_PARAMS} from "./constans";

let initialState = {
    bookings: null,
    statusList: null,
    navParams: {
        page: 1
    }
};

const bookingReducers = (state = initialState, action) => {
    switch (action.type) {
        case SET_BOOKING_LIST:
            return {
                ...state,
                bookings: action.payload
            }
        case SET_NAV_PARAMS:
            return {
                ...state,
                navParams: action.payload
            }
        case SET_STATUS_LIST:
            return {
                ...state,
                statusList: action.payload
            }
        case UPDATE_BOOKINGS:
            return {
                ...state,
                bookings: {...state.bookings, ...action.payload}
            }


        default:
            return state;
    }
};


export default bookingReducers;